import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type RawPCMember = {
  'First Name': string;
  'Last Name': string;
  Title: string;
  Affiliation: string;
  Country: string;
  Email: string;
  Status: string;
  Homepage?: string;
  Image?: string;
};

export type PCMember = {
  title: string;
  firstName: string;
  lastName: string;
  affiliation: string;
  country: string;
  image?: string;
  homepage?: string;
};

export type WorkshopChair = {
  name: string;
  affiliation: string;
  image?: string;
};

export type WorkshopData = {
  year: number;
  title: string;
  description: string;
  conference: string;
  location: string;
  locationImage?: string;
  dates: {
    start: string;
    end: string;
  };
  importantDates: {
    submissionDeadline: string;
    notificationDate: string;
    cameraReadyDeadline: string;
  };
  scope: string;
  topics: string[];
  chairs: WorkshopChair[];
  callForPapers: {
    description: string;
    submissionUrl: string;
    guidelinesUrl: string;
    templatesUrl: string;
  };
};

export function convertPCMembersJSON(members: RawPCMember[]): PCMember[] {
  const res = members
    .filter((member) => member.Status === 'accepted')
    .map((member) => ({
      title: member.Title,
      firstName: member['First Name'],
      lastName: member['Last Name'],
      affiliation: member.Affiliation,
      country: member.Country,
      image: member.Image,
      homepage: member.Homepage
    }));
  return res;
}
